import React, { createContext, useContext } from "react";

import {
  DashboardBillingChartsValue,
  DashboardBillingValues,
} from "libLegacy/api/models";

export type BillingStore = {
  isLoading: boolean;
  hasError: string | false;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  monthData: DashboardBillingValues;
  downloadInvoicePDF: (downloadUrl: string) => string;
  isDownloading: boolean;
  invoice: DashboardBillingValues["invoiceApproval"];
  yearData: DashboardBillingChartsValue;
};

const BillingContext = createContext<Partial<BillingStore>>({});

export const BillingProvider = ({ children, store }) => (
  <BillingContext.Provider value={store}>{children} </BillingContext.Provider>
);

export const useMonthlyBillsContext = () => {
  const { isLoading, monthData, downloadInvoicePDF, isDownloading } =
    useContext(BillingContext);

  return { isLoading, monthData, downloadInvoicePDF, isDownloading };
};

export const useInvoiceDetailsContext = () => {
  const { isLoading, invoice, monthData } = useContext(BillingContext);
  const { clientName, finalBillingAmount, supplierKey, taxNumber } =
    monthData || {};
  const client = { clientName, supplierKey, taxNumber };

  return { isLoading, invoice, balance: finalBillingAmount, client };
};

export const useYearlyBillsContext = () => {
  const { isLoading, yearData } = useContext(BillingContext);
  return { isLoading, ...yearData };
};
